(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flabom-offer-strip"] && !Shopify.designMode) return;
  try {
    
  class FlabomOfferStrip extends HTMLElement {
    connectedCallback() {
      this.slidesWrap = this.querySelector('[data-fb-offer-slides]');
      this.slides = Array.from(this.querySelectorAll('[data-fb-offer-slide]'));
      this.index = 0;

      this.querySelector('[data-fb-offer-prev]')?.addEventListener('click', () => this.go(-1));
      this.querySelector('[data-fb-offer-next]')?.addEventListener('click', () => this.go(1));

      const interval = this.slidesWrap?.dataset.autorotate;
      if (interval) {
        this.timer = setInterval(() => this.go(1), Number(interval));
      }
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    go(direction) {
      if (this.slides.length < 2) return;
      this.slides[this.index].hidden = true;
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.slides[this.index].hidden = false;
    }
  }

  if (!customElements.get('fb-offer-strip')) {
    customElements.define('fb-offer-strip', FlabomOfferStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
